// import React, { useState, useRef } from "react";
// import { FaMicrophone } from "react-icons/fa";
// import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
// import { billpunchbasicauth } from "../utils/Credentials";

// const VoiceAssistant = () => {
//   const [listening, setListening] = useState(false);
//   const [text, setText] = useState("");
//   const [aiLoading, setAiLoading] = useState(false);

//   const recognitionRef = useRef(null);

//   const { username, password } = billpunchbasicauth;

//   const speakResponse = (message) => {
//     if (!message) return;

//     const speech = new SpeechSynthesisUtterance(message);

//     speech.lang = "en-US"; 
//     speech.rate = 1;
//     speech.pitch = 1;

//     window.speechSynthesis.cancel();
//     window.speechSynthesis.speak(speech);
//   };

//   const handleAiAsk = async (spokenText) => {
//     setAiLoading(true);

//     try {
//       const base64Credentials = btoa(`${username}:${password}`);

//       const res = await fetch(
//         // `${BASE_URL_API_TRANXT_UAT_API}/api/Ai/ask`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Basic ${base64Credentials}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             text: spokenText,
//           }),
//         }
//       );

//       const data = await res.json();
//       console.log("AI Response:", data);

//       if (data?.message) {
//         const message = data.message;
      
//         speakResponse(message); // 🔊 NOW IT WILL SPEAK
//         return message;
//       } else {
//         console.error("AI Error:", data);
//         speakResponse("Sorry, response nahi mila");
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       speakResponse("Network error aaya hai");
//     } finally {
//       setAiLoading(false);
//     }
//   };

//   // 🎤 START LISTENING
//   const startListening = () => {
//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;

//     if (!SpeechRecognition) {
//       alert("Speech Recognition not supported in this browser");
//       return;
//     }

//     const recognition = new SpeechRecognition();

//     recognition.continuous = false; // ✅ IMPORTANT (single result)
//     recognition.lang = "en-US";
//     recognition.interimResults = false;

//     recognition.onstart = () => {
//       console.log("🎤 Listening...");
//       setListening(true);
//       setText("");
//     };

//     recognition.onresult = async (event) => {
//       const transcript = event.results[0][0].transcript;

//       console.log("You said:", transcript);
//       setText(transcript);

//       // ✅ stop after one input
//       recognition.stop();
//       setListening(false);

//       // 🤖 call AI
//       await handleAiAsk(transcript);
//     };

//     recognition.onerror = (err) => {
//       console.error("Speech Error:", err);
//       setListening(false);
//     };

//     recognition.onend = () => {
//       setListening(false);
//     };

//     recognition.start();
//     recognitionRef.current = recognition;
//   };

//   // 🛑 STOP LISTENING
//   const stopListening = () => {
//     recognitionRef.current?.stop();
//     setListening(false);
//   };

//   return (
//     <>
//       {/* 🎤 FULL SCREEN LISTENING UI */}
//       {listening && (
//         <div style={styles.overlay}>
//           <div style={styles.centerBox}>
//             <div style={styles.wave}></div>
//             <p style={styles.listeningText}>Listening...</p>
//             <p style={styles.transcript}>{text}</p>
//           </div>
//         </div>
//       )}

//       {/* 🤖 LOADING UI */}
//       {aiLoading && (
//         <div style={styles.loaderOverlay}>
//           <p style={{ color: "#fff", fontSize: "18px" }}>
//             Processing...
//           </p>
//         </div>
//       )}

//       {/* 🎤 MIC BUTTON */}
//       <div style={styles.container}>
//         <div
//           style={{
//             ...styles.micButton,
//             ...(listening ? styles.active : {}),
//           }}
//           onClick={listening ? stopListening : startListening}
//         >
//           <FaMicrophone />
//         </div>
//       </div>
//     </>
//   );
// };

// // 🎨 STYLES
// const styles = {
//   container: {
//     position: "fixed",
//     bottom: "20px",
//     right: "20px",
//     zIndex: 9999,
//   },

//   micButton: {
//     width: "60px",
//     height: "60px",
//     borderRadius: "50%",
//     background: "#007bff",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#fff",
//     cursor: "pointer",
//     fontSize: "20px",
//   },

//   active: {
//     background: "#ff4d4f",
//   },

//   // 🎤 LISTENING OVERLAY
//   overlay: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     background: "rgba(0,0,0,0.7)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9998,
//   },

//   centerBox: {
//     textAlign: "center",
//     color: "#fff",
//   },

//   wave: {
//     width: "120px",
//     height: "120px",
//     borderRadius: "50%",
//     background: "#ff4d4f",
//     margin: "0 auto",
//     animation: "pulse 1.2s infinite",
//   },

//   listeningText: {
//     marginTop: "15px",
//     fontSize: "18px",
//     opacity: 0.8,
//   },

//   transcript: {
//     marginTop: "10px",
//     fontSize: "20px",
//     fontWeight: "bold",
//   },

//   // 🤖 LOADER
//   loaderOverlay: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     background: "rgba(0,0,0,0.6)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9997,
//   },
// };

// export default VoiceAssistant;

import React, { useState, useRef } from "react";
import { FaMicrophone } from "react-icons/fa";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import { billpunchbasicauth } from "../utils/Credentials";
import SiriWave from "./animation";

const VoiceAssistant = () => {
  const [listening, setListening] = useState(false);
  const [text, setText] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiResponse, setAiResponse] = useState("");
  const recognitionRef = useRef(null);

  const { username, password } = billpunchbasicauth;

  const speakResponse = (message) => {
    if (!message) return;
  
    const speech = new SpeechSynthesisUtterance(message);
  
    speech.lang = "en-US";
  
    speech.onend = () => {
      setAiResponse(""); 
    };
  
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(speech);
  };

  const handleAiAsk = async (spokenText) => {
    setAiLoading(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Ai/ask`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            text: spokenText,
          }),
        }
      );

      const data = await res.json();
      console.log("AI Response:", data);

      if (data?.message) {
        const message = data.message;
      
  setAiResponse(message);
        speakResponse(message); 
        return message;
      } else {
        console.error("AI Error:", data);
        speakResponse("Error");
      }
    } catch (error) {
      console.error("API Error:", error);
      speakResponse("Network error ");
    } finally {
      setAiLoading(false);
    }
  };

  
  const startListening = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Speech Recognition not supported in this browser");
      return;
    }

    const recognition = new SpeechRecognition();

    recognition.continuous = false; // ✅ IMPORTANT (single result)
    recognition.lang = "en-US";
    recognition.interimResults = false;

    recognition.onstart = () => {
      console.log("🎤 Listening...");
      setListening(true);
      setText("");
    };

    recognition.onresult = async (event) => {
      const transcript = event.results[0][0].transcript;

      console.log("You said:", transcript);
      setText(transcript);

      // ✅ stop after one input
      recognition.stop();
      setListening(false);

      // 🤖 call AI
      await handleAiAsk(transcript);
    };

    recognition.onerror = (err) => {
      console.error("Speech Error:", err);
      setListening(false);
    };

    recognition.onend = () => {
      setListening(false);
    };

    recognition.start();
    recognitionRef.current = recognition;
  };

  // 🛑 STOP LISTENING
  const stopListening = () => {
    recognitionRef.current?.stop();
    setListening(false);
  };

  return (
    <>
 {(listening || aiLoading || aiResponse) && <SiriWave />}
 {(listening || aiLoading || aiResponse) && (
  <div style={styles.centerText}>
    {listening && <p>Listening...</p>}
    {aiLoading && <p>Processing...</p>}
    {aiResponse && <p>{aiResponse}</p>}
  </div>
)}
      <div style={styles.container}>
        <div
          style={{
            ...styles.micButton,
            ...(listening ? styles.active : {}),
          }}
          onClick={listening ? stopListening : startListening}
        >
          <FaMicrophone />
        </div>
      </div>
    </>
  );
};

// 🎨 STYLES
const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 9999,
  },
  centerText: {
    position: "fixed",
    top: "calc(50% + 70px)", // 👈 pushes text BELOW the circle
    left: "50%",
    transform: "translateX(-50%)",
    color: "#fff",
    fontSize: "18px",
    textAlign: "center",
    zIndex: 9999,
    maxWidth: "80%",
  },
  micButton: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#007bff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    cursor: "pointer",
    fontSize: "20px",
  },

  active: {
    background: "#ff4d4f",
  },

  // 🎤 LISTENING OVERLAY
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9998,
  },

  centerBox: {
    textAlign: "center",
    color: "#fff",
  },

  wave: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    background: "#ff4d4f",
    margin: "0 auto",
    animation: "pulse 1.2s infinite",
  },

  listeningText: {
    marginTop: "15px",
    fontSize: "18px",
    opacity: 0.8,
  },

  transcript: {
    marginTop: "10px",
    fontSize: "20px",
    fontWeight: "bold",
  },

  // 🤖 LOADER
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9997,
  },
};

export default VoiceAssistant;